import React from "react";
import { ViewStyle } from "react-native";
import { Circle } from "./AHTheme/Circle";
import { AHText, AHTextFonts } from "./Text/AHText";

export type AssignedUserCircleProps = {
  name: string;
  style?: ViewStyle;
  borderWidth?: number;
  isMe?: boolean;
};
function AssignedUserCircle(props: AssignedUserCircleProps) {
  return (
    <Circle
      size="smallMedium"
      color={props.isMe ? "darkerText" : "surface"}
      borderColor="border-primary"
      borderWidth={props.borderWidth ?? 1}
      style={props.style}
    >
      <AHText
        type="info-small"
        color={props.isMe ? "text-inverted" : "text-secondary"}
      >
        {props.name
          .split(" ")
          .slice(0, 2)
          .map((n) => n[0]?.toLocaleUpperCase())
          .join("")}
      </AHText>
    </Circle>
  );
}

export function UserCircle(props: {
  name: string;
  style?: ViewStyle;
  borderWidth?: number;
}) {
  return (
    <Circle
      size="smallMedium"
      color={"background"}
      borderColor="surface-primary"
      borderWidth={props.borderWidth ?? 2}
      style={props.style}
    >
      <AHText size={9} color={"text-secondary"} font={AHTextFonts.BOLD}>
        {props.name
          .split(" ")
          .slice(0, 2)
          .map((n) => n[0]?.toLocaleUpperCase())
          .join("")}
      </AHText>
    </Circle>
  );
}
